import * as React from 'react'
import { Avatar } from '@material-ui/core'
import '../styles/SideMenuHeader.scss'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface SideMenuHeaderProps {
  avatar?: any
  firstName?: string
  lastName?: string
  onAvatarClick?: () => void
}

export class SideMenuHeader extends React.Component<SideMenuHeaderProps, {}> {
  private readonly defaultAvatar = require('../styles/icons/avatar/avatar2.png')
  constructor(props: any) {
    super(props)
  }

  onAvatarClick = (event: any) => {
    event.stopPropagation()
  }

  onClick = (event: any) => {
    event.stopPropagation()
  }

  render() {
    const avatarSrc = this.props.avatar ? this.props.avatar : this.defaultAvatar
    const firstName = this.props.firstName ? this.props.firstName : StringResources.getString(Strings.Components.SideMenuHeader.Text.unknownFirstName)
    const lastName = this.props.lastName ? this.props.lastName : StringResources.getString(Strings.Components.SideMenuHeader.Text.unknownLastName)

    return (
      <div className="side-menu-header" onClick={this.onClick} tabIndex={0} >
        <Avatar
          src={avatarSrc}
          className="side-menu-avatar"
          onClick={this.onAvatarClick}
        />

        <div className="side-menu-header-info">
          <span>{firstName}</span>
          <br />
          <span>{lastName}</span>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SideMenuHeader.tsx